import { IPlanCardProps } from "components/landingPage/planCard";
import { getCurrentSubscription, getPlans } from "network/apis/stripe";
import { useQuery } from "react-query";
import { QUERIES } from "utils/constants";
import CrownIcon from "assets/crown.svg";

export const useSubscriptionPlansWithCurrentSubscription = () => {
  return useQuery(
    [QUERIES.LOAD_SUBSCRIPTION_PLANS_WITH_CURRENT_SUBSCRIPTION],
    async () => {
      const data = await Promise.all([getPlans(), getCurrentSubscription()]);
      return data;
    },
    {
      keepPreviousData: true,
      select: (data) => {
        return data[0].data
          .filter(
            (plan) => plan.active === true && plan.product.active === true
          )
          .map((plan) => {
            let planInterval = plan.recurring.interval;
            planInterval =
              planInterval.charAt(0).toUpperCase() + planInterval.slice(1);

            const planCard: IPlanCardProps = {
              priceId: plan.id,
              planName: `${planInterval}ly\nPlan`,
              isRecommended: planInterval === "Year",
              planPrice: plan.unit_amount / 100,
              planPeriod: planInterval as "Month",
              themeType: "light",
              isCurrentPlan: data[1].priceId === plan.id,
              icon: CrownIcon,
              features: plan.product.features.map((f) => f.name),
              isSubscribed: data[1].subscribed,
              savedValue: plan.product.metadata.saved_value || 0,
              savedPercentage: plan.product.metadata.saved_percentage || 0
            };
            return planCard;
          });
      }
    }
  );
};

export const useCurrentSubscription = () =>
  useQuery([QUERIES.LOAD_CURRENT_SUPSCRIPTION], getCurrentSubscription);

export const useSubscriptionPlans = () => {
  return useQuery([QUERIES.LOAD_SUBSCRIPTION_PLANS], getPlans, {
    select: (data) => {
      return data.data
        .filter((plan) => plan.active === true && plan.product.active === true)
        .map((plan) => {
          let planInterval = plan.recurring?.interval;
          planInterval =
            planInterval?.charAt(0)?.toUpperCase() + planInterval?.slice(1);

          const planCard: IPlanCardProps = {
            priceId: plan.id,
            planName: `${planInterval}ly\nPlan`,
            isRecommended: planInterval === "Year",
            planPrice: plan.unit_amount / 100,
            planPeriod: planInterval as "Month",
            themeType: "light",
            isCurrentPlan: false,
            icon: CrownIcon,
            features: plan.product.features.map((f) => f.name),
            isSubscribed: false,
            savedValue: plan.product.metadata.saved_value || 0,
            savedPercentage: plan.product.metadata.saved_percentage || 0
          };
          return planCard;
        });
    }
  });
};
